/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationDataConnectionsGetDataCommand interface.
 */
export function instanceOfFxIdApplicationDataConnectionsGetDataCommand(value) {
    if (!('QueryTitle' in value) || value['QueryTitle'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationDataConnectionsGetDataCommandFromJSON(json) {
    return FxIdApplicationDataConnectionsGetDataCommandFromJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsGetDataCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'QueryTitle': json['QueryTitle'],
    };
}
export function FxIdApplicationDataConnectionsGetDataCommandToJSON(json) {
    return FxIdApplicationDataConnectionsGetDataCommandToJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsGetDataCommandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'QueryTitle': value['QueryTitle'],
    };
}
//# sourceMappingURL=FxIdApplicationDataConnectionsGetDataCommand.js.map